export enum MediaType {
  MOVIE = "movie",
  TV = "tv",
  ANIME = "anime",
  DONGHUA = "donghua"
}